import React from 'react';
import { iconSizer } from "../../../../../icons2022/iconSizer";
import { FolderIcon24Regular } from "../../../../../icons2022/FileTypeFolderIcon/FolderIcon24Regular";
import { FolderIcon32Regular } from "../../../../../icons2022/FileTypeFolderIcon/FolderIcon32Regular";
import { FolderIcon64Regular } from "../../../../../icons2022/FileTypeFolderIcon/FolderIcon64Regular";
export var FolderIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(FolderIcon24Regular, null);
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(FolderIcon32Regular, null);
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(FolderIcon64Regular, null);
  }
}, 'FolderIcon');